import axios from 'axios'
import {vm} from '@/main'

var baseUrl = process.env.VUE_APP_BASE_URL

const dashboard = {
    state: {
        allDashboardData: null,
        dashboard: null,

    },

    mutations: {
        setAllDashboardData(state, dashboard){
            state.allDashboardData = dashboard
        },
        setPreviousMonthDashboard(state){
            state.dashboard = state.allDashboardData.previousMonth
        },
        setThisMonthDashboard(state){
            state.dashboard = state.allDashboardData.thisMonth
        },
        setThisWeekDashboard(state){
            state.dashboard = state.allDashboardData.thisWeek
        },
        setDayDashboard(state){
            state.dashboard = state.allDashboardData.today
        },


    },

    actions: {

        getDashboardData({commit, rootState}){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {
                axios.get(baseUrl +'/api/dashboard')
                    .then(response => {
                        commit('setAllDashboardData', response.data.dashboard)
                        commit('setThisMonthDashboard')
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error)
                        if (error.response.status === 401) {
                            context.dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },
        getPreviousMonthDashboard({commit}){
            commit('setPreviousMonthDashboard')
        },

        getThisMonthDashboard({commit}){
            commit('setThisMonthDashboard')
        },

        getThisWeekDashboard({commit}){
            commit('setThisWeekDashboard')
        },

        getLastDayDashboard({commit}){
            commit('setDayDashboard')
        },

    },
    getters: {
        allDashboardData(state){
            return state.allDashboardData
        },
        dashboard(state){
            return state.dashboard
        }
    }
}

export default dashboard